import React from 'react';

import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';

export function LoadingSkeleton({ className }: { className?: string }) {
  return (
    <div className={className}>
      <ShimmerLoading className="mx-2 my-1 h-4 w-9/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-7/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-10/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-2/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-1/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-9/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-8/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-10/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-2/12" />
      <ShimmerLoading className="mx-2 my-1 h-4 w-10/12" />
    </div>
  );
}
